module.exports = __webpack_public_path__ + "img/app-all.89841c3a.png";